@if (data) {
    <cerrix-workspace
        [tabID]="tabID"
        [cerrixTab]="tab"
        [data]="data"
        [headerLookup]="headerLookup"
        [module]="'test plan'"
        [moduleType]="moduleType"
        [appendToModuleType]="appendToModuleType"
        [idProp]="'guid'"
        [permissions]="permissions"
        [filterConfig]="filterConfigs"
        [rendererConfig]="rendererConfig"
        [buttonConfig]="buttonConfig"
        [NumberProperties]="numberProps"
        [DateProperties]="dateProps"
        (onDblClick)="open($event)"
    >
    </cerrix-workspace>
}
